import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  pending: {
    tasks: [],
    pagination: null,
  },
  completed: {
    tasks: [],
    pagination: null,
  },
  scheduled: {
    tasks: [],
    pagination: null,
  },
  archived: {
    tasks: [],
    pagination: null,
  },
};

const taskSlice = createSlice({
  name: 'tasks',
  initialState,
  reducers: {
    setTasks: (state, action) => {
      const { filter, data, pagination } = action.payload;
      if (state[filter]) {
        const parsedTasks = data.map((task) => ({
          ...task,
          schedule_json: task.schedule_json ? JSON.parse(task.schedule_json) : null,
        }));
        state[filter].tasks = parsedTasks;
      }
      if (pagination) {
        state[filter].pagination = pagination;
      }
    },
  },
});

export const { setTasks } = taskSlice.actions;

export default taskSlice.reducer;
